import { Directive, Input, OnDestroy, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { Subject, Subscription, fromEvent, timer } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
    selector: '[debounceClick]'
})
export class DebounceClickDirective implements OnInit, OnDestroy {

    @Input() debouncetime = 500;
    @Output() debounceclicked = new EventEmitter()
    clicks = new Subject();
    subscription: Subscription;

    constructor(
        private el: ElementRef
    ) {

    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
    ngOnInit(): void {
        this.subscription = this.clicks.pipe(
            debounceTime(this.debouncetime)
        ).subscribe(e => {
            this.debounceclicked.emit(e)
        });
        this.clickevent()
    }

    // @HostListener('click', ['$event'])
    clickevent() {
        if (typeof window !== 'undefined' && this.el.nativeElement) {
            fromEvent(this.el.nativeElement, 'click').pipe(debounceTime(10)).subscribe((res: any) => {
                res.preventDefault();
                if (res.stopPropagation) res.stopPropagation();
                this.el.nativeElement.disabled = true
                timer(this.debouncetime).subscribe(() => {
                    this.clicks.next(true);
                    this.el.nativeElement.disabled = false;
                })
            })
        }

    }
}